<template>
  <div>
    <b-form-group
      class="mb-0"
    >
      <legend class="col-form-label pt-0">
        Type *
        <GjIcon name="Info" v-b-tooltip.hover="$tk('ClientPortal.Schedule.ScheduleTypeInfo')"/>
      </legend>
      <b-form-radio
        v-for="cronType in cronTypes"
        :key="cronType.id"
        v-model.number="model.typeId"
        :value="cronType.id"
        :state="errors['Cron'] == null ? null : false"
        @input="updateCronValue"
      >
        {{ cronType.name }}
      </b-form-radio>

      <b-form-invalid-feedback :force-show="errors['Cron'] != null">
        {{ errors['Cron'] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      v-if="isHourly"
      class="mt-2"
    >
      <v-select
        v-model="model.scheduledHours"
        :clearable="false"
        :placeholder="$tk('ClientPortal.Survey.ChooseHour')"
        :options="croncHours"
        @option:selected="updateCronValue"
      />
    </b-form-group>
    <b-form-group
      v-if="isWeekly"
      class="mt-2 mb-0"
    >
      <v-select
        v-model="model.scheduledDay"
        :clearable="false"
        label="text"
        :placeholder="$tk('ClientPortal.Survey.ChooseDay')"
        :options="cronDays"
        :reduce="cronc => cronc.value"
        @option:selected="updateCronValue"
      />
    </b-form-group>
    <b-form-group
      v-if="isDaily || isWeekly"
      class="mt-2 mb-0"
    >
      <vue-timepicker
        v-model="model.scheduledTime"
        hour-label="hour"
        minute-label="minute"
        class="vue-timepicker-up"
        @change="updateCronValue"
      />
    </b-form-group>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import vSelect from 'vue-select'

const CRON_TYPE = Object.freeze({
  HOURLY: 1,
  DAILY: 2,
  WEEKLY: 3,
})

export default {
  components: {
    VueTimepicker,
    GjIcon,
    vSelect,
  },
  props: {
    cronTypes: Array,
    cronDays: Array,
    errors: Object,
  },
  data() {
    return {
      model: {
        typeId: 0,
        scheduledHours: 1,
        scheduledTime: '00:00',
        scheduledDay: 0,
      },
      croncHours: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
      ],
    }
  },
  computed: {
    isHourly() {
      return this.model.typeId === CRON_TYPE.HOURLY
    },
    isDaily() {
      return this.model.typeId === CRON_TYPE.DAILY
    },
    isWeekly() {
      return this.model.typeId === CRON_TYPE.WEEKLY
    },
  },
  mounted() {
    this.setCronValue()
  },
  methods: {
    setCronValue() {
      const cronValue = this.$attrs.value
      if (cronValue != null) {
        if (cronValue.startsWith('0 */') && cronValue.endsWith('* * *')) {
          this.model.typeId = CRON_TYPE.HOURLY
        } else if (cronValue.endsWith('*/1 * *')) {
          this.model.typeId = CRON_TYPE.DAILY
        } else {
          this.model.typeId = CRON_TYPE.WEEKLY
        }
        const scheduleType = this.model.typeId
        // eslint-disable-next-line no-unused-vars
        const [minutes, hours, _, __, dayOfWeek] = cronValue.split(' ')
        if (scheduleType === CRON_TYPE.HOURLY) {
          this.model.scheduledHours = hours.split('/').pop()
        } else if (scheduleType === CRON_TYPE.DAILY) {
          this.model.scheduledTime = `${hours}:${minutes}`
        } else if (scheduleType === CRON_TYPE.WEEKLY) {
          this.model.scheduledTime = `${hours}:${minutes}`
          this.model.scheduledDay = dayOfWeek
        }
      }
    },
    updateCronValue() {
      var cronValue = this.getCronValue()
      this.$emit('input', cronValue)
    },
    getCronValue() {
      if (this.model.typeId === CRON_TYPE.HOURLY) {
        return `0 */${this.model.scheduledHours} * * *`
      } if (this.model.typeId === CRON_TYPE.DAILY) {
        const [hour, minute] = this.model.scheduledTime.split(':')
        return `${minute} ${hour} */1 * *`
      } if (this.model.typeId === CRON_TYPE.WEEKLY) {
        const [hour, minute] = this.model.scheduledTime.split(':')
        return `${minute} ${hour} */1 * ${this.model.scheduledDay}`
      }

      return ''
    },
  },
}
</script>

<style src="vue2-timepicker/dist/VueTimepicker.css" />
